export default __webpack_public_path__ + "static/media/booth-red.523d34f2.svg";